import { useOrganizationList, useClerk } from '@clerk/clerk-react';
import { resetAnalytics } from '@tagadapay/analytics';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Navigate } from 'react-router-dom';
import { CreateAccount } from '@/components/ui/create-account';
import { Loader2 } from 'lucide-react';

/**
 * Create Account Page - accessed from org switcher when user wants to create a new account
 * This is different from /no-organization which is shown automatically after sign up/in
 */
export default function CreateAccountPage() {
  const { userMemberships, isLoaded } = useOrganizationList({
    userMemberships: {
      pageSize: 10,
    },
  });
  const { signOut } = useClerk();

  // If loading, show loading state
  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="text-muted-foreground mx-auto h-8 w-8 animate-spin" />
          <p className="text-muted-foreground mt-4 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Create account success handler
  const handleAccountCreated = (orgSlug: string) => {
    window.location.href = `/org/${orgSlug}`;
  };

  return (
    <div className="bg-background flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-2xl space-y-4">
        <Card className="p-6 sm:p-8">
          <CardContent className="p-0">
            <CreateAccount onAccountCreated={handleAccountCreated} />
          </CardContent>
        </Card>

        <div className="text-center">
          <Button
            variant="link"
            onClick={() => {
              resetAnalytics();
              signOut();
            }}
            size="sm"
            className="text-muted-foreground"
          >
            Sign out and try a different account
          </Button>
        </div>
      </div>
    </div>
  );
}

